function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M128.363 81.1694C178.63 -25.6006 374.625 81.1694 128.363 218.419C-117.9 81.1694 78.0951 -25.6006 128.363 81.1694Z",
  fill: "var(--n-color-white)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M128.363 223.92C127.44 223.92 126.518 223.689 125.685 223.225C77.5401 196.392 42.7031 168.836 22.1401 141.323C-0.217926 111.407 -0.550946 88.3468 3.10705 74.2708C6.40605 61.5738 14.2251 50.8268 25.7181 43.1918C36.4101 36.0898 49.844 32.1787 63.548 32.1787C90.201 32.1787 113.799 45.9918 128.363 69.6198C142.927 45.9918 166.525 32.1787 193.177 32.1787C206.882 32.1787 220.32 36.0898 231.012 43.1918C242.507 50.8268 250.326 61.5737 253.626 74.2717C257.283 88.3467 256.95 111.406 234.591 141.322C214.027 168.835 179.187 196.39 131.04 223.225C130.208 223.688 129.286 223.92 128.363 223.92ZM63.548 43.1787C39.027 43.1787 19.0161 56.7847 13.7541 77.0367C9.37909 93.8757 15.3251 113.828 30.9521 134.737C50.2061 160.499 82.9691 186.523 128.364 212.115C173.76 186.521 206.526 160.497 225.781 134.735C241.409 113.827 247.356 93.8747 242.981 77.0367C237.718 56.7847 217.704 43.1787 193.178 43.1787C167.6 43.1787 145.231 58.2567 133.34 83.5127C132.432 85.4407 130.494 86.6698 128.363 86.6698C126.233 86.6698 124.294 85.4407 123.387 83.5127C111.496 58.2567 89.126 43.1787 63.548 43.1787Z",
  fill: "black"
});

function SvgIconHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.65e591d241ef7d988ee273899377e55d.svg";
export { ForwardRef as ReactComponent };